<template>
  <div class="banner_content">
    <div class="banner_content_left">
      <div class="banner_content_left_title">{{ returnTitle() }}</div>
    </div>
    <div class="banner_content_img" :style="`background-image:url(${returnImage()})`"></div>
  </div>
</template>

<script>
import imageOption from "@/mixins/imageOption";
import util from "@/mixins/util";

export default {
  name: "BannerLayout",
  mixins: [imageOption],
  components: {},
  props: {
    infoData: {},
  },
  data() {
    return {
      type: ''
    }
  },
  beforeRouterEnter() {
  },
  created() {
    this.type = this.$route.name
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    returnImage() {
      return `${this.infoData.org_url}?${this.setImageOptions(468, 272, 'jpg')}`;
    },
    returnTitle() {
      this.setType();
      let type = this.type
      switch (type) {
        case "Intro":
          return '함께하는 아버지들?'
        case "News":
          return '뉴스'
        case "Donate":
          return '나눔&배움'
        case "Amidan":
          return '아미단'
        case "Album":
          return '앨범'
          case "term":
              return '서비스 이용약관'
          case "privacy":
              return '개인정보 처리방침'
      }
    },
    setType() {
      if (this.type === 'BusinessDetail' || this.type === 'FinancialDetail') {
        this.type = 'Intro'
      }
      if (this.type === 'NewsDetail') {
        this.type = 'News'
      }
      if (this.type === 'DonateDetail' || this.type === 'DonatePrimeDetail') {
        this.type = 'Donate'
      }
      if (this.type === 'AmidanDetail') {
        this.type = 'Amidan'
      }
      if (this.type === 'AlbumDetail') {
        this.type = 'Album'
      }
        if (this.type === 'Term') {
            this.type = 'term'
        }
        if (this.type === 'Privacy') {
            this.type = 'privacy'
        }
    }
  },
  watch: {},
}
</script>

<style scoped>

</style>